import createModule from './create-module'

let simpleModules = [
    'filings',
    'violations',
    'determinations',
    'trackings',
    'misc-services',
    'dot-permits',
    'after-hours-permits',
    'occupancy-certificates',
    'inspections',
    'permits'
]

let modules = {
    //..
}

_.each(simpleModules, moduleName => modules[moduleName] = createModule(moduleName))

export default modules
